// The kinds of point in Elements/CheckList: fine (a green tick), worth knowing (a blue i), needs a look (an amber
// triangle).
const CheckListToneEnum = {
  Ok: 'ok',
  Info: 'info',
  Warn: 'warn',
};

export default CheckListToneEnum;
